import { templateIntegrationInformation } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { IntegrationInformationWebComponent } from '../component/IntegrationInformationWebComponent';
import { IntegrationInformationWebView } from '../view/IntegrationInformationWebView';

export class IntegrationInformationWebController extends BaseWebComponentController {
  public component: IntegrationInformationWebComponent;
  public view: IntegrationInformationWebView;
  public viewConstructor: typeof IntegrationInformationWebView;

  constructor(component: IntegrationInformationWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: IntegrationInformationWebView,
      viewTemplate: templateIntegrationInformation,
    });
  }
}
